import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseColorsModel } from '../models/base-colors.model';
import { ConfigurationService } from '../shared/services/configuration.service';
import { ColorsModel } from '../models/colors.model';
import { Guid } from 'guid-typescript';

@Injectable({
  providedIn: 'root'
})
export class PoolColorsService {
  private readonly http = inject(HttpClient);
  private readonly configSvc = inject(ConfigurationService);

  private backUrl

  constructor() {
    this.backUrl = `${this.configSvc.productApiUrl}api/`;
  }
  
  getColors(): Observable<Array<BaseColorsModel>> {
    return this.http.get<Array<BaseColorsModel>>(this.backUrl + 'products/colors');
  }
  
  getColorById(id: Guid): Observable<ColorsModel> {
    return this.http.get<ColorsModel>(`${this.backUrl}products/productColors/${id}`);
  }
  
}